import React from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";

import CustomText from "../../common/general/CustomText/CustomText";
import SubmissionRow from "./SubmissionRow";
import { ModalState } from "../../../views/adminViews/GradingCenterView";
import { useGradingCenterSubmissions } from "../../../contexts/GradingCenterContext";
import { UnifiedSubmission } from "../../../graphql/generated/graphql";

interface GradingCenterTableProps {
  setModalState: React.Dispatch<React.SetStateAction<ModalState>>;
}

const GradingCenterTable: React.FC<GradingCenterTableProps> = ({ setModalState }) => {
  const { filteredSubmissions, setSelectedSubmissionData, isLoading } = useGradingCenterSubmissions();

  const handleGradePress = (submission: UnifiedSubmission) => {
    setSelectedSubmissionData(submission);
    if (submission.submissionType === "Assignment") {
      setModalState(ModalState.VIEW_ASSIGNMENT_RESPONSE);
    } else if (submission.submissionType === "Assessment") {
      setModalState(ModalState.VIEW_ASSESSMENT_RESPONSE);
    } else if (submission.submissionType === "Project") {
      setModalState(ModalState.VIEW_PROJECT_RESPONSE);
    }
  };

  return (
    <View style={styles.tableDataContainer}>
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableHeader}>
          <View style={[styles.cell, styles.studentCell]}>
            <CustomText weight="bold" text="Student" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.typeCell]}>
            <CustomText weight="bold" text="Submission Type" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.courseCell]}>
            <CustomText weight="bold" text="Course" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.moduleCell]}>
            <CustomText weight="bold" text="Module" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.dateCell]}>
            <CustomText weight="bold" text="Submitted on" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.statusCell]}>
            <CustomText weight="bold" text="Status" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.gradeCell]}>
            <CustomText weight="bold" text="Grade" size="s" style={styles.headerText} />
          </View>
          <View style={[styles.cell, styles.actionsCell]}>
            <CustomText weight="bold" text="Action" size="s" style={styles.headerText} />
          </View>
        </View>

        {/* Table Body */}
        {isLoading ? (
          <View style={styles.loaderContainer}>
            <ActivityIndicator size="large" color="#0000ff" />
          </View>
        ) : filteredSubmissions?.length > 0 ? (
          filteredSubmissions.map((submission) => (
            <SubmissionRow key={submission.id} submission={submission} onGradePress={handleGradePress} />
          ))
        ) : (
          <View style={styles.emptyState}>
            <CustomText text="No data found" style={styles.emptyText} />
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  loaderContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 16,
  },
  tableDataContainer: {
    flex: 1,
  },
  table: {
    backgroundColor: "#fff",
  },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#F9FAFB",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    paddingVertical: 12,
    paddingHorizontal: 24,
  },
  cell: {
    justifyContent: "center",
    paddingHorizontal: 8,
  },
  studentCell: {
    flex: 2.5,
  },
  typeCell: {
    flex: 1.5,
  },
  courseCell: {
    flex: 1.5,
  },
  moduleCell: {
    flex: 1,
  },
  dateCell: {
    flex: 1.5,
  },
  statusCell: {
    flex: 1.5,
  },
  gradeCell: {
    flex: 1,
  },
  actionsCell: {
    flex: 1,
    alignItems: "flex-start",
  },
  headerText: {
    color: "#475569",
    fontSize: 12,
    letterSpacing: 0.5,
  },
  emptyState: {
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  emptyText: {
    color: "#6B7280",
    marginBottom: 8,
  },
});

export default GradingCenterTable;
